import Cookies from 'js-cookie';

const REFRESH_TOKEN_KEY = 'yadAdminRefreshToken';

const getCookieOptions = (): Cookies.CookieAttributes => {
  const isProduction = window.location.protocol === 'https:';

  return {
    expires: 30, // 30 days
    path: '/',
    sameSite: 'strict',
    secure: isProduction,
  };
};

export const getRefreshToken = (): string | null => {
  try {
    return Cookies.get(REFRESH_TOKEN_KEY) || null;
  } catch (error) {
    console.error('Error accessing refresh token cookie:', error);
    return null;
  }
};

export const setRefreshToken = (token: string): void => {
  try {
    Cookies.set(REFRESH_TOKEN_KEY, token, getCookieOptions());
  } catch (error) {
    console.error('Error setting refresh token in cookie:', error);
  }
};

export const removeAuthToken = (): void => {
  try {
    Cookies.remove(REFRESH_TOKEN_KEY, { path: '/' });
  } catch (error) {
    console.error('Error removing refresh token cookie:', error);
  }
};
